import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';

import {environment} from "../../environments/environment";
import {IbanCheckExternalRequest} from "../model/requests/IbanCheckExternalRequest";
import {FinalResponse} from "../model/responses/finalResponse";

const BASE_URL = environment.baseUrl;

@Injectable({
  providedIn: 'root'
})
export class CheckibanApiService {

  constructor(private httpClient: HttpClient) {
  }

  public async function1PostApiiban(body: IbanCheckExternalRequest, observe: any = 'body', reportProgress = false): Promise<FinalResponse | undefined> {
    return await firstValueFrom(
      this.httpClient.request<FinalResponse>('post', `${BASE_URL}/api/iban`, {
        body: body,
        observe: 'body', // Assicurati che 'observe' sia impostato su 'body' per ricevere il payload della risposta
        reportProgress: reportProgress
      })
    );
  }

}
